import React from 'react';

/**
 * Loading placeholders shaped like the content that is arriving, so nothing
 * jumps when the real thing lands. The shimmer itself is gated behind
 * prefers-reduced-motion: no-preference in index.css.
 */
export function Skeleton({ width, height, radius, className = '' }) {
  return (
    <div
      className={`skeleton ${className}`.trim()}
      style={{ width, height, borderRadius: radius }}
      aria-hidden="true"
    />
  );
}

/**
 * `minWidth` should match the real grid's minmax so the placeholder lays out in
 * the same columns the content will land in.
 */
export function CardGridSkeleton({ count = 6, minWidth }) {
  return (
    <div className="skeleton-grid" style={minWidth ? { '--skeleton-col': minWidth } : undefined}>
      {Array.from({ length: count }, (_, i) => (
        <div className="skeleton-card" key={i}>
          <Skeleton className="skeleton-card-image" />
          <div className="skeleton-card-body">
            <Skeleton height={14} width="80%" />
            <Skeleton height={12} width="45%" />
            <Skeleton height={12} width="65%" />
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * Whole-app placeholder for the route guard: the sidebar rail plus a card grid,
 * which is the shape of every authenticated route.
 */
export function AppSkeleton() {
  return (
    <div className="app-skeleton" role="status" aria-label="Loading">
      <div className="app-skeleton-sidebar">
        <Skeleton height={40} radius="var(--radius-md)" />
        <Skeleton height={12} width="40%" />
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} height={28} radius="var(--radius-md)" />
        ))}
      </div>
      <div className="app-skeleton-main">
        <div className="app-skeleton-header">
          <Skeleton height={28} width={180} />
          <Skeleton height={36} width={320} radius="var(--radius-lg)" />
        </div>
        <div className="app-skeleton-body">
          <CardGridSkeleton />
        </div>
      </div>
    </div>
  );
}
